import { Customer } from "@hydrologiq/gql-experience/graphql"
import RunDry from "@hydrologiq/shared/asset/attributes/RunDry"

interface CustomerRunDryIconProps {
  customer: Customer
  icon?: boolean
}

function CustomerRunDryIcon({ customer, icon = true }: CustomerRunDryIconProps) {
  const earliestRunDryMinutes = customer.earliestInstallationRunDryMinutes
  const earliestRunDryAsset = customer.earliestInstallationRunDryAsset

  return (
    <RunDry
      minutes={earliestRunDryMinutes ?? undefined}
      asset={earliestRunDryAsset ?? undefined}
      icon={icon}
    />
  )
}

export default CustomerRunDryIcon
